import React, { Component } from 'react';
import { ClimbingBoxLoader } from 'react-spinners'
// import axios from 'axios';
import PropTypes from 'prop-types';

class Shuttle extends Component {

  static contextTypes = {
    router: PropTypes.object
  }

  constructor() {
    super()
    // const reservationData = this.props.location.state.params
    // console.log('DATA', reservationData)

    this.state = {
      firstName: '',
      lastName: '',
      email: '',
      date: '',
      passangers: '',
      firstAddress: '',
      lastAddress: '',
      roundTrip: '',
      message: '',
      phoneNumber: null,
      showNameError: false,
      showEmailError: false,
      showDateError: false,
      showAddressError: false,
      showSuccessMessage: false,
      showFailureMessage: false,
      showLoader: false
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  // componentDidMount() {
  //   console.log('DATA1', this.props.location)

  //   if (this.props.location.state) {
  //     let reservationData = this.props.location.state.params
  //     console.log('DATA', reservationData)
  //     this.setState({
  //       date:reservationData.reservation.departure,
  //       passangers: reservationData.reservation.passangers,
  //       firstAddress: reservationData.reservation.from,
  //       lastAddress: `${reservationData.reservation.to} - Please write your address`,
  //       roundTrip: reservationData.reservation.returnTrip,
  //     })
  //   }
  // }


  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value })
  }

  async handleSubmit(e) {
    e.preventDefault()

    const { firstName, lastName, email, date, firstAddress, lastAddress, passangers, roundTrip, message, phoneNumber } = this.state;

    if (firstName.trim().length < 1 || lastName.trim().length < 1) {
      this.setState({
        showNameError: true,
        showEmailError: false,
        showDateError: false,
        showAddressError: false
      })
    } else if (email.trim().length < 1) {
      this.setState({
        showNameError: false,
        showEmailError: true,
        showDateError: false,
        showAddressError: false
      })
    } else if (!date) {
      this.setState({
        showNameError: false,
        showEmailError: false,
        showDateError: true,
        showAddressError: false
      })
    } else if (firstAddress.trim().length < 1 || lastAddress.trim().length < 1) {
      this.setState({
        showNameError: false,
        showEmailError: false,
        showDateError: false,
        showAddressError: true
      })
    } else {

      this.setState({
        showNameError: false,
        showEmailError: false,
        showDateError: false,
        showAddressError: false
      })
      const templateId = 'template_1f9ezos';

      this.sendEmail(templateId, { firstName, lastName, email, date, passangers, firstAddress, lastAddress, roundTrip, message, phoneNumber, type: 'Airport Shuttle' })
      // await this.sendRequest();
      // await this.redirect();
    }
  }

  sendEmail(templateId, variables) {
    this.setState({ showLoader: true })

    window.emailjs.send('service_q3cdma8', templateId, variables, 'user_wUiv2JBaQkOPoP3f91WaK')
      .then((res) => {
        this.setState({ showSuccessMessage: true, showLoader: false })
      })
      .catch(err => this.setState({ showFailureMessage: true, showLoader: false })
      )

  }

  showErrorText = () => {
    if (this.state.showNameError) {
      return (
        <p className="errorMsg">Name is required!</p>
      );
    } if (this.state.showEmailError) {
      return (
        <p className="errorMsg">Email address is required!</p>
      );
    } if (this.state.showDateError) {
      return (
        <p className="errorMsg">Date is required!</p>
      );
    } if (this.state.showAddressError) {
      return (
        <p className="errorMsg">Address is required!</p>
      );
    }
  }

  renderSuccessPopup = () => {
    const { showFailureMessage, showSuccessMessage } = this.state;
    if (showSuccessMessage) {
      return (
        <div className="detailsContainer">
          <div className="detailsPopup">
            <p className="successHeader">Success</p>
            <p className="successText">Your message has been sent. We will contact you soon.</p>
            <button className="successButton" onClick={() => this.onClosePopup('success')}>OK</button>
          </div>
          <div className="ui-widget-overlay" />
        </div>
      );
    } else if (showFailureMessage) {
      return (
        <div className="detailsContainer">
          <div className="detailsPopup">
            <p className="failureHeader">Failure</p>
            <p className="successText">Error while trying to send message, please try again or contact us directly on phone or email.</p>
            <button className="failureButton" onClick={() => this.onClosePopup('failure')}>OK</button>
          </div>
          <div className="ui-widget-overlay" />
        </div>
      );
    } else {
      return null;
    }
  }

  onClosePopup = (value) => {
    this.setState({
      showFailureMessage: false,
      showSuccessMessage: false
    })
    if (value === 'success') {
      this.context.router.history.push(`/`);
    }
  }

  // sendRequest = () => {
  //   const { firstName, lastName, email, date, passangers, firstAddress, lastAddress, roundTrip, message, phoneNumber } = this.state;

  //   axios.post('shuttle/form', {
  //     firstName,
  //     lastName,
  //     email,
  //     date,
  //     passangers,
  //     firstAddress,
  //     lastAddress,
  //     roundTrip,
  //     message,
  //     phoneNumber
  //   })
  // }

  // redirect = () => {
  //   this.context.router.history.push(`/success`);
  // }

  render() {
    // console.log("cccc", this.props.location.state)
    // const reservation = null;
    // if(this.props.location.state){
    //   reservation 
    // }
    return this.state.showLoader ? (
      <div style={{
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}>
        <ClimbingBoxLoader
          color='#5967c3' size={20} loading={this.state.showLoader} />
      </div>
    ) : (
      <div className="airport">
        {this.renderSuccessPopup()
        }
        <div className="text-airport ">

          <h3>Sarajevo Airport Transfer</h3>
          <p><strong>As a partner specialized in Sarajevo airport transfers we help you reach your destiantion safely.</strong></p>
          {/* <p className="promotianalText">From 15€ inside Sarajevo city area!</p>
          <p className="promotianalText">Round trip from 25€!</p> */}
        </div>
        <form onSubmit={this.handleSubmit}>
          <div className="airportName">
            <div className="airportFirstName">
              <label>First Name</label>
              <input type="text" className="form-control" name="firstName" maxLength="20"
                placeholder="First name" onChange={this.handleChange} />
            </div>
            <div className="airportLastName">
              <label for="lastName">Last Name</label>
              <input type="text" className="form-control" name="lastName" maxLength="20"
                placeholder="Last name" onChange={this.handleChange} />
            </div>
          </div>
          {this.state.showNameError && (
            <div className="errorMsg">
              <p>Name is reqiured</p>
            </div>
          )}
          <div className="form-group airpotInputs">
            <label for="InputEmail">Email address</label>
            <input type="email" className="form-control" id="InputEmail" maxLength="40"
              name="email" aria-describedby="emailHelp" placeholder="Enter email" onChange={this.handleChange} />
            {this.state.showEmailError && (
              <div className="errorMsg">
                <p>Email is reqiured</p>
              </div>
            )}
          </div>
          <div className="form-group airpotInputs">
            <label for="inputDate">Date of arrival</label>
            <input type="date" className="form-control" name="date"
              id="inputDate" onChange={this.handleChange} />
            {this.state.showDateError && (
              <div className="errorMsg">
                <p>Date is reqiured</p>
              </div>
            )}
          </div>
          <div className="form-group airpotInputs">
            <label for="FormSelect">Number of passangers</label>
            <select className="form-control" name="passangers" id="FormSelect" onChange={this.handleChange}>
              <option>1</option>
              <option>2</option>
              <option>3</option>
              <option>4</option>
              <option>5</option>
              <option>6</option>
              <option>7</option>
              <option>8</option>
            </select>
          </div>
          <div className="form-group airpotInputs">
            <label for="PickUp">Pick Up Address</label>
            <input type="text" className="form-control" id="PickUp" maxLength="50"
              name="firstAddress" value={this.props.location.state ? this.props.location.state.params : this.state.firstAddress} placeholder="Pick Up Address" onChange={this.handleChange} />
          </div>
          {this.state.showAddressError && (
            <div className="errorMsg">
              <p>Address is reqiured</p>
            </div>
          )}
          <div className="form-group airpotInputs">
            <label for="DropOff">Drop Off Address</label>
            <input type="text" className="form-control" id="DropOff" name="lastAddress" maxLength="50"
              placeholder="Your Destination" onChange={this.handleChange} />
          </div>
          <div className="form-group airpotInputs">
            <label for="Select">Round trip:</label>
            <select className="form-control" name="roundTrip" id="Select" onChange={this.handleChange}>
              <option>Yes</option>
              <option>No</option>
            </select>
          </div>
          <div className="form-group airpotInputs">
            <label for="phoneNumber">Phone Number</label>
            <input type="number" className="form-control" id="phoneNumber" name="phoneNumber"
              onChange={this.handleChange} placeholder="Your phone number" />
          </div>
          <div className="form-group airpotInputs">
            <label for="Textarea1">Message:</label>
            <textarea className="form-control" name="message" maxLength="300" id="Textarea1" rows="4" onChange={this.handleChange}></textarea>
          </div>
          <div className="form-group airpotInputs btnErrorMsg">
            <button type="submit" className="btn btn-primary purpleButton">Submit</button>
            {this.showErrorText()}
          </div>
        </form>
      </div >
    );
  }
}

export default Shuttle;